import { put, select } from 'redux-saga/effects'
// import { setForm3Section } from "../../actions";
import { serverRequest } from "../../actions";

import { getForm3ActiveSection, getForm3Nodes, getForm3Id, getForm3Data, getForm3Validations } from '../../reducers'
// import validateField from './_validateField'


/**
 * request a section change
 * 
 * this function is called before a section change takes place. it is called from redux-saga and will issue
 * the correct redux-action if a change is allowed.
 * 
 * NOTE: This function will mutate the action parameter and modify the index
 * NOTE: _validateSection has to be run in order for showHide to function properly. This is very important!
 * 
 * 
 * Special case: Previous (i.e. clicking previous / dir <= 0 ) should always granted passage through. 
 * 
 * @param {*} action - The redux action
 */
export function* requestForm3Section(action) {

  const { index, direction,ignoreValidationErrors,force, effects } = action

  const activeSection = yield select(getForm3ActiveSection)
  const formId = yield select(getForm3Id)
  const formNodes = yield select(getForm3Nodes)
  const rootNode = formNodes[formId];
  const sectionId = rootNode.structure[activeSection]
  const formData = yield select(getForm3Data)

  var payload = {
    action: "form/requestForm3Section",
    formId,
    formDataId: formData._id,
    sectionId,
    index, 
    direction,
    ignoreValidationErrors,
    force,
    effects
  };

  yield put(serverRequest(payload));


  return

}

export default requestForm3Section